import type { RouteRecordRaw } from 'vue-router';

import AuthenticateView from '@views/Authentication/AuthenticateView.vue';
import LogoutView from '@views/Authentication/LogoutView.vue';

const routes: RouteRecordRaw[] = [
    {
        path: '/authenticate',
        name: 'authenticate',
        components: {
            default: AuthenticateView,
        },
        meta: {
            anonymous: true,
        },
    },
    {
        path: '/logout',
        name: 'logout',
        components: {
            default: LogoutView,
        },
        meta: {
            anonymous: true,
        },
    },
];

export default routes;
